import styled from 'styled-components';

const Button = styled.button`
  width: 18px;
  border: none;
  background-color: ${({ theme }) => theme.buttons.tertiary.background};
`;

export default Button;
